import { render, staticRenderFns } from "./ContactsCard.vue?vue&type=template&id=56be2546&scoped=true"
import script from "./ContactsCard.vue?vue&type=script&lang=js"
export * from "./ContactsCard.vue?vue&type=script&lang=js"
import style0 from "./ContactsCard.vue?vue&type=style&index=0&id=56be2546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be2546",
  null
  
)

export default component.exports